import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "#3CC64A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.32923 15.2293L5.85423 11.7543L4.6709 12.9293L9.32923 17.5876L19.3292 7.5876L18.1542 6.4126L9.32923 15.2293Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 6,
			width: 16,
			height: 12,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.32923 15.2293L5.85423 11.7543L4.6709 12.9293L9.32923 17.5876L19.3292 7.5876L18.1542 6.4126L9.32923 15.2293Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgCheckIcon);
export default ForwardRef;
